// النموذج العام للمنصة: أنواع السجلات والتقارير والشاشات وأدوات الوكلاء والقواعد والخدمات والبيئات.
export default {
  generic: {
    stats: {
      total: "التعريفات", totalHint: "المفاتيح في هذا الفهرس",
      published: "المنشورة", publishedHint: "لها نسخة منشورة",
      drafts: "المسودات", draftsHint: "مسودات مفتوحة أو قيد المراجعة",
    },
    search: "البحث بالاسم أو المفتاح",
    filters: { unpublished: "لم تنشر من قبل" },
    noMatch: "لا توجد نتائج مطابقة لهذه المرشحات.",
    createIntro: "اسم ومفتاح فقط. يمكن تغيير كل شيء لاحقا باستثناء المفتاح.",
    keyHint: "أحرف لاتينية صغيرة وأرقام ونقاط وشرطات. يستخدم في الروابط والحزم ولا يمكن تغييره.",
    createOpen: "إنشاء وفتح",
    created: "تم الإنشاء. النسخة 1 مسودة.",
    notFound: "غير موجود",
    notFoundBody: "لا يوجد تعريف بالمفتاح «{{key}}». ربما تم تجاهله.",
    publishedNotice: "هذه النسخة منشورة. لتعديلها تلزم نسخة جديدة، وتبقى هذه النسخة منشورة حتى نشر النسخة الجديدة.",
    stageBody: "تنضم المسودة إلى الإصدار الحالي، وتصبح سارية عند اعتماد الإصدار ونشره، ويمكن التراجع عنها من صفحة الإصدارات.",
    stageTitle: "نشر {{name}}",
    tabs: { code: "الشيفرة", versions: "النسخ" },
    lint: { name: "الاسم مطلوب." },
    condition: {
      always: "دائما",
      custom: "شرط مخصص (انظر JSON)",
      match: "المطابقة",
      allOf: "جميع الشروط",
      anyOf: "أي شرط",
      and: "و",
      or: "أو",
      field: "الحقل",
      operator: "الشرط",
      value: "القيمة",
      add: "إضافة شرط",
      json: "JSON",
      simple: "العودة إلى العرض المبسط",
      ops: {
        eq: "يساوي", neq: "لا يساوي", gt: "أكبر من", gte: "لا يقل عن", lt: "أقل من", lte: "لا يزيد على",
        empty: "فارغ", filled: "معبأ", contains: "يحتوي على", oneOf: "أحد القيم",
      },
    },
  },
  records: {
    referenceHint: "رقم السجل أو معرفه ({{type}})",
  },
  reports: {
    title: "التقارير",
    subtitle: "جداول ورسوم بيانية عن السجلات أو الحالات، تعد من دون برمجة، وتعمل على البيانات الفعلية، وتصدر بصيغة CSV أو Excel.",
    new: "تقرير جديد",
    emptyTitle: "لا توجد تقارير بعد",
    emptyBody: "يمكن إنشاء تقرير عن نوع سجل أو عن حالات خدمة: أعداد حسب الشهر، أو مجاميع حسب القطاع، أو قائمة مصفاة.",
    help: {
      what: "يقرأ التقرير سجلات نوع ما أو حالات خدمة ما، ويبقي الصفوف المطابقة لمرشحه، ثم يعرضها قائمة أو يجمعها مع الأعداد والمجاميع والمتوسطات.",
      export: "تراعي التقارير صلاحيات الإدارات، فيرى كل شخص الصفوف المسموح له بها فقط. ويسجل كل تصدير في سجل التدقيق.",
    },
    summary: "المصدر: {{source}} · {{chart}}",
    tabs: { design: "التصميم", results: "النتائج" },
    source: {
      title: "المصدر", intro: "مصدر الصفوف.", kind: "الصفوف", records: "سجلات نوع", cases: "حالات خدمة",
      recordType: "نوع السجل", service: "الخدمة", includeTest: "تضمين السجلات والحالات التجريبية",
    },
    filter: { title: "المرشح", intro: "إبقاء الصفوف المطابقة فقط. وتركه فارغا يعني جميع الصفوف." },
    shape: {
      title: "التخطيط", intro: "عرض الصفوف بأعمدة مختارة، أو تجميعها وحساب الأرقام.",
      list: "قائمة", grouped: "مجمع", groupBy: "التجميع حسب", thenBy: "ثم حسب (اختياري)", measures: "الأرقام", fn: "الحساب", field: "الحقل",
      addMeasure: "إضافة رقم", columns: "الأعمدة", columnsHint: "عدم تحديد أي عمود يعرض أول ثمانية حقول.", chart: "الرسم البياني",
    },
    bucket: { month: "حسب الشهر", year: "حسب السنة" },
    fns: { count: "العدد", sum: "المجموع", avg: "المتوسط", min: "الأدنى", max: "الأعلى" },
    charts: { table: "جدول فقط", bar: "أعمدة", line: "خطي", pie: "دائري", kpi: "أرقام رئيسية" },
    caseFields: { caseNumber: "رقم الحالة", title: "العنوان", state: "المرحلة", status: "الحالة", priority: "الأولوية", createdAt: "تاريخ الإنشاء", workspaceKey: "الإدارة", isTest: "تجريبي" },
    preview: { title: "المعاينة", intro: "تشغيل هذه المسودة على البيانات الفعلية من دون حفظ أي شيء.", run: "تشغيل", empty: "يلزم تحديد المصدر لمعاينة التقرير." },
    results: { title: "النتائج", published: "النسخة المنشورة {{version}} على البيانات الفعلية.", latest: "أحدث نسخة على البيانات الفعلية.", refresh: "تحديث" },
    lint: {
      source: "يلزم تحديد مصدر الصفوف.",
      measureField: "الرقم «{{name}}» يحتاج إلى حقل.",
      chartNeedsGroup: "الرسوم البيانية تحتاج إلى صفوف مجمعة. يلزم تجميع الصفوف أو اختيار «جدول فقط».",
    },
  },
  recordTypes: {
    title: "البيانات",
    subtitle: "تحدد أنواع السجلات البيانات التي تحتفظ بها الإدارة، من حقول وروابط وتحققات، من دون برمجة أو تعديل لقاعدة البيانات. ويتحقق الخادم من كل سجل عند حفظه.",
    new: "نوع سجل جديد",
    emptyTitle: "لا توجد أنواع سجلات بعد",
    emptyBody: "يمكن إنشاء نوع سجل لأي سجل تحتفظ به الإدارة: الدراسات أو التراخيص أو عمليات التفتيش أو الشكاوى.",
    help: {
      what: "نوع السجل قائمة حقول مع تحققاتها. ونشره ينشئ سجلا يضيف إليه الموظفون السجلات ويبحثون فيه ويعدون التقارير منه. ولا ينشأ جدول جديد، إذ تحفظ كل السجلات في مخزن مشترك مفهرس.",
      checks: "تعمل التحققات على الخادم بالمحرك نفسه المستخدم للنماذج المقدمة، فيرفض السجل المخالف أيا كانت الشاشة أو المنظومة التي تكتبه.",
      extension: "يمكن لنوع السجل أن يوسع خدمة، فتحمل كل حالة من حالاتها سجلا من هذا النوع، وبذلك تضيف الإدارة حقولها الخاصة إلى الحالات المشتركة.",
    },
    stats: { records: "السجلات", recordsHint: "في جميع الأنواع" },
    columns: { fields: "الحقول", records: "السجلات", owner: "الجهة المالكة" },
    shared: "مشترك بين جميع الإدارات",
    extends: "يوسع {{service}}",
    summary: "الحقول: {{fields}} · الروابط: {{links}} · التحققات: {{checks}} · بادئة الأرقام {{prefix}}",
    tabs: { fields: "الحقول", links: "الروابط", checks: "التحققات", settings: "الإعدادات", try: "تجربة سجل", records: "السجلات" },
    types: { text: "نص", longText: "نص طويل", number: "رقم", money: "مبلغ (درهم)", date: "تاريخ", boolean: "نعم / لا", choice: "اختيار", email: "بريد إلكتروني", reference: "ربط بسجل" },
    typeHelp: {
      text: "سطر نصي واحد. ويمكن تحديد حد أقصى للطول أو نمط للتحقق من الصيغة.",
      longText: "عدة أسطر نصية، مثل الوصف أو الملخص.",
      number: "رقم. ويمكن تحديد حد أدنى وحد أقصى لرفض القيم خارج النطاق.",
      money: "مبلغ بالدرهم، ولا يقبل القيم السالبة ما لم يحدد حد أدنى خلاف ذلك.",
      date: "تاريخ تقويمي.",
      boolean: "مفتاح نعم / لا.",
      choice: "قيمة واحدة من قائمة خيارات ثابتة.",
      email: "عنوان بريد إلكتروني يتحقق من صيغته.",
      reference: "رقم سجل من نوع آخر، ويتحقق من وجوده.",
    },
    fields: {
      intro: "الترتيب هنا هو ترتيب الحقول في الشاشات. تحديد الحقل يفتح إعداداته.",
      none: "لا توجد حقول بعد.",
      newLabel: "الحقل {{n}}",
      add: "إضافة حقل",
      type: "النوع",
      label: "التسمية",
      labelAr: "التسمية بالعربية",
      keyHint: "يستخدم في التحققات والتقارير والتصدير.",
      help: "نص المساعدة",
      helpAr: "نص المساعدة بالعربية",
      min: "الحد الأدنى",
      max: "الحد الأقصى",
      maxLength: "الحد الأقصى للطول",
      pattern: "الصيغة (تعبير نمطي)",
      patternHint: "اختياري، مثل ^[0-9]{6}$ لرقم من ست خانات.",
      target: "نوع السجل المرتبط",
      options: "الخيارات",
      optionValue: "القيمة المخزنة",
      addOption: "إضافة خيار",
      required: "مطلوب",
      searchable: "قابل للبحث",
      listed: "يظهر في القوائم",
      useAsTitle: "استخدامه عنوانا للسجل",
      title: "العنوان",
      up: "نقل لأعلى",
      down: "نقل لأسفل",
      emptyTitle: "إضافة الحقل الأول",
      emptyBody: "يكفي تحديد النوع وإضافة الحقل. ويمكن إعادة الترتيب والتسمية والحذف حتى نشر النوع.",
    },
    links: {
      intro: "تربط الروابط السجل بالحالات أو بسجلات من أنواع أخرى، فيمكن تصفح السجل من أي من الجانبين.",
      none: "لا توجد روابط بعد.",
      add: "إضافة رابط",
      target: "يرتبط بـ",
      case: "حالة",
      many: "يسمح بأكثر من واحد",
    },
    checks: {
      intro: "يرفض التحقق السجل أو ينبه عليه عند تحقق شرطه، ويمكنه المقارنة بين عدة حقول.",
      none: "لا توجد تحققات بعد. وتطبق تحققات الحقول (مطلوب، الحد الأدنى، الصيغة) من دون إضافة أي شيء هنا.",
      add: "إضافة تحقق",
      flagWhen: "تنبيه على السجل عندما",
      message: "الرسالة",
      messageAr: "الرسالة بالعربية",
      severityLabel: "الأثر",
      severity: { error: "رفض", warning: "تنبيه" },
    },
    settings: {
      about: "نبذة",
      numbering: "الأرقام والملكية",
      numberingHint: "ترقم السجلات تلقائيا، مثل {{example}}.",
      prefix: "بادئة الرقم",
      titleField: "عنوان السجل",
      titleFieldHint: "يظهر في القوائم ونتائج البحث.",
      numberAsTitle: "رقم السجل",
      owner: "الإدارة المالكة",
      ownerHint: "يطلع الموظفون على سجلات إداراتهم والسجلات المشتركة.",
      extends: "توسيع حالات خدمة",
      extendsHint: "تحمل كل حالة من حالات الخدمة سجلا واحدا من هذا النوع يعبأ من الحالة.",
      tags: "الوسوم",
    },
    try: {
      title: "تجربة سجل",
      intro: "تعبئة سجل تجريبي والتحقق منه على الخادم وفق حقول هذه النسخة وتحققاتها. ولا يحفظ أي شيء.",
      check: "التحقق على الخادم",
      saveTest: "حفظه سجلا تجريبيا",
      saved: "تم حفظ السجل التجريبي {{number}}.",
      publishFirst: "يمكن حفظ السجلات التجريبية بعد نشر نسخة.",
      needFields: "تلزم إضافة حقول قبل تجربة سجل.",
      result: "النتيجة",
      noResult: "تظهر هنا نتيجة التحقق على الخادم.",
      valid: "السجل يجتاز جميع التحققات",
      validBody: "سيقبل الخادم هذا السجل.",
      invalid: "المشكلات: {{count}}",
    },
    records: {
      intro: "السجلات المحفوظة في هذا النوع: {{count}}.",
      includeTest: "تضمين السجلات التجريبية",
      new: "سجل جديد",
      none: "لا توجد سجلات بعد.",
      number: "الرقم",
      titleCol: "العنوان",
      test: "تجريبي",
      archived: "مؤرشف",
      saved: "تم حفظ السجل {{number}}.",
      archive: "أرشفة",
      restore: "استعادة",
      notPublished: "لم ينشر بعد",
      notPublishedBody: "يمكن إضافة السجلات بعد نشر النسخة الأولى من هذا النوع.",
    },
    lint: {
      fieldKey: "مفتاح الحقل «{{key}}» يجب أن يبدأ بحرف لاتيني صغير ويتكون من أحرف أو أرقام أو _.",
      fieldTwice: "المفتاح «{{key}}» مستخدم مرتين.",
      fieldLabel: "الحقل «{{key}}» يحتاج إلى تسمية.",
      options: "حقل الاختيار «{{key}}» يحتاج إلى خيار واحد على الأقل.",
      target: "حقل الربط «{{key}}» يحتاج إلى نوع السجل المرتبط.",
      range: "الحقل «{{key}}»: الحد الأدنى أكبر من الحد الأقصى.",
      linkKey: "مفتاح الرابط «{{key}}» يجب أن يبدأ بحرف لاتيني صغير ويتكون من أحرف أو أرقام أو _.",
      linkTarget: "الرابط «{{key}}» يحتاج إلى وجهة.",
      prefix: "بادئة الرقم من 2 إلى 8 أحرف لاتينية كبيرة أو أرقام، تبدأ بحرف.",
      titleField: "حقل العنوان ليس من الحقول.",
      checkMessage: "التحقق «{{key}}» بلا رسالة.",
      noFields: "يلزم حقل واحد على الأقل قبل النشر.",
    },
  },
  serviceDesigner: {
    title: "الخدمات",
    subtitle: "كل إجراء تديره المنصة. الإجراء الجديد نموذج وسير عمل ورقم قضية وأدوار تجمع هنا ثم تنشر عبر إصدار دون برمجة.",
    new: "خدمة جديدة",
    emptyTitle: "لا توجد خدمات بعد",
    emptyBody: "تربط الخدمة نموذج الطلب وسير العمل بإدارة وأدوارها وأرقام قضاياها.",
    help: {
      what: "الخدمة إجراء واحد: ما يبدؤه المتعاملون أو الموظفون، والنموذج الذي يجمع الطلب، وسير العمل الذي يديره، ومن يعمل عليه.",
      dynamic: "الخدمات الديناميكية تجمع هنا من نماذج وسير عمل منشورة وتفتح قضايا عامة. الخدمات المبرمجة إجراءات مبنية بالكود، وتعدل بطاقتها ووثائقها وأدوارها هنا أيضا.",
      release: "تسري التغييرات عبر إصدار: تضاف المسودة إلى الإصدار وتعتمد، ويمكن التراجع عنها من صفحة الإصدارات.",
    },
    stats: { open: "القضايا المفتوحة", openHint: "في جميع الخدمات" },
    columns: { kind: "النوع", code: "الرمز", category: "الفئة", workflow: "سير العمل", cases: "المفتوحة / الكل" },
    kind: { Dynamic: "ديناميكية", Compiled: "مبرمجة" },
    audience: { External: "المتعاملون (البوابة)", Internal: "الموظفون فقط", Any: "المتعاملون والموظفون" },
    summary: "{{kind}} · الرمز {{code}} · سير العمل {{workflow}}",
    compiledTitle: "إجراء مبرمج",
    compiledBody: "تشغل هذه الخدمة الإجراء المدمج {{type}}. يمكن تعديل بطاقتها ووثائقها وأدوارها ونمط أرقامها هنا، أما خطواتها فمثبتة في الكود.",
    tabs: { overview: "نظرة عامة", process: "الإجراء", documents: "الوثائق", access: "الإدارة والأدوار" },
    identity: { title: "الهوية", intro: "اسم الخدمة وتصنيفها في الفهرس." },
    card: { title: "بطاقة الفهرس", intro: "ما يقرؤه المتعامل قبل البدء." },
    fields: {
      category: "الفئة", categoryAr: "الفئة (بالعربية)", audience: "من يبدؤها", icon: "الأيقونة", portalVisible: "ظاهرة على البوابة", sortOrder: "الترتيب",
      summary: "الملخص", summaryAr: "الملخص (بالعربية)", legalBasis: "السند القانوني", legalBasisAr: "السند القانوني (بالعربية)", processingTime: "مدة المعالجة", processingTimeAr: "مدة المعالجة (بالعربية)",
      workflow: "سير العمل", form: "نموذج الطلب", rules: "قواعد الأهلية", automations: "الأتمتة", agents: "الوكلاء المسموح لهم على قضاياها",
      code: "الرمز", codeHint: "من 2 إلى 6 أحرف لاتينية كبيرة أو أرقام، فريد بين الخدمات.", pattern: "نمط رقم القضية",
      fees: "الرسوم", templates: "قوالب الخطابات", department: "الإدارة", flag: "علامة الميزة على البوابة", accessRoles: "الأدوار التي ترى قضاياها وتعمل عليها", startRoles: "الأدوار التي يمكنها بدؤها",
    },
    process: {
      title: "النموذج وسير العمل", intro: "يجمع النموذج الطلب، وتديره حالات سير العمل ومهامه وقواعده ومهله.",
      live: "منشور، والنسخة المنشورة تدير القضايا الجديدة.", notLive: "غير منشور بعد، ويلزم نشره في استوديو سير العمل قبل تفعيل هذه الخدمة.", pickWorkflow: "سير عمل من القائمة، أو سير عمل جديد في استوديو سير العمل.",
      draft: "مسودة", openWorkflow: "استوديو سير العمل", openForm: "منشئ النماذج", noForm: "دون نموذج طلب", formHint: "النماذج المنشورة من منشئ النماذج.", formDraft: "لا توجد نسخة منشورة لهذا النموذج بعد.",
      rulesHint: "تفحص عند تقديم الطلب، والقاعدة غير المستوفاة توقفه برسالتها.", none: "لا شيء",
    },
    numbers: { title: "أرقام القضايا", intro: "تحصل كل قضية جديدة على الرقم التالي وفق هذا النمط.", tokens: "{code} {yyyy} {yy} {mm} و{seq:0000} واحد", examples: "الأرقام التالية:" },
    fees: { title: "الرسوم والخطابات", intro: "جداول الرسوم المستحقة عند التقديم والخطابات التي ترسلها قضاياها.", free: "دون رسوم" },
    documents: { title: "الوثائق المطلوبة", intro: "القائمة التي يراها المتعامل، والوثائق الإلزامية شرط للتقديم.", none: "لا توجد وثائق مطلوبة.", name: "الوثيقة", nameAr: "الوثيقة (بالعربية)", required: "إلزامية", add: "إضافة وثيقة" },
    access: {
      department: "الإدارة", departmentIntro: "الإدارة المالكة للخدمة، وتحفظ قضاياها وسجلاتها وتقاريرها لدى تلك الإدارة.", shared: "مشتركة (جميع الإدارات)",
      flagHint: "اختياري. ما دامت العلامة معطلة تبقي البوابة نموذج الطلب السابق لهذه الخدمة.",
      roles: "الأدوار", rolesIntro: "أدوار الإدارة أولا، وتخفى أدوار الإدارات الأخرى بعد تحديد الإدارة.",
      accessHint: "الفراغ يعني جميع أدوار الموظفين.", startHint: "للخدمات التي يبدؤها الموظفون. الفراغ يعني جميع أدوار الموظفين.", everyone: "جميع أدوار الموظفين",
    },
    lint: {
      code: "يجب أن يكون الرمز من 2 إلى 6 أحرف لاتينية كبيرة أو أرقام.",
      pattern: "يحتاج نمط رقم القضية إلى الرمز {seq:0000}.",
      workflow: "لا يوجد سير عمل بعد، ولا يمكن نشر الخدمة دونه.",
      form: "يحتاج المتعاملون إلى نموذج طلب لبدء هذه الخدمة على البوابة.",
      document: "كل وثيقة تحتاج إلى اسم ومفتاح.",
      documentTwice: "وثيقتان بالمفتاح نفسه.",
    },
  },
  rules: {
    title: "القواعد",
    subtitle: "الشروط التي تفحصها سير العمل والخدمات والأتمتة. تكتب جدول قرار أو تعبيرا، وتختبر قبل تفعيلها.",
    new: "قاعدة جديدة",
    emptyTitle: "لا توجد قواعد بعد",
    emptyBody: "تجيب القاعدة عن سؤال واحد بشأن القضية من بياناتها: هل تسمح بالخطوة، وهل المتعامل مؤهل، وما قيمة الرسم.",
    help: {
      what: "يستخدم سير العمل القاعدة المنشورة شرطا على خطوة (rule:key)، وتفحص الخدمات قواعد الأهلية عند تقديم الطلب، وتستخدمها الأتمتة شروطا.",
      table: "يقرأ جدول القرار من الأعلى إلى الأسفل: أول صف تطابق خلاياه كلها يحدد النتيجة، وإلا ينطبق السطر الأخير.",
      tests: "لكل قاعدة حالات اختبار خاصة بها، ولا تنشر القاعدة حتى تنجح جميعها.",
    },
    stats: { tested: "الاختبارات الناجحة", testedHint: "القواعد التي نجح آخر اختبار لها" },
    columns: { kind: "النوع", form: "الصيغة", tests: "آخر اختبار", service: "الخدمة" },
    platformWide: "على مستوى المنصة",
    kinds: { Guard: "شرط سير عمل", Eligibility: "أهلية", Condition: "شرط أتمتة", Validation: "فحص نموذج", Computation: "حساب" },
    kindHints: {
      Guard: "يظهر في استوديو سير العمل شرطا على خطوة.",
      Eligibility: "يفحص عند تقديم طلب الخدمة.",
      Condition: "تستخدمه الأتمتة لتقرر التنفيذ.",
      Validation: "فحص بين حقول النموذج.",
      Computation: "يعطي قيمة (رسما أو أولوية) بدلا من نعم أو لا.",
    },
    modes: { table: "جدول قرار", logic: "تعبير" },
    fields: { kind: "النوع", mode: "الصيغة", service: "الخدمة", explanation: "الشرح", explanationAr: "الشرح (بالعربية)" },
    summary: "{{kind}} · حالات الاختبار: {{tests}}",
    tabs: { logic: "المنطق", tests: "حالات الاختبار", case: "التجربة على قضية", settings: "الإعدادات" },
    ops: { any: "أي قيمة", eq: "يساوي", neq: "لا يساوي", gt: "أكبر من", gte: "لا يقل عن", lt: "أقل من", lte: "لا يزيد على", between: "بين", oneOf: "أحد", contains: "يحتوي", empty: "فارغ", filled: "معبأ" },
    table: {
      intro: "عمود لكل قيمة تقرؤها القاعدة، وصف لكل حالة. أول صف مطابق يحدد النتيجة.",
      input: "المدخل", operator: "العامل", holds: "تتحقق؟", result: "النتيجة", yes: "نعم", no: "لا", otherwise: "غير ذلك (لا يطابق أي صف)",
      addRow: "إضافة صف", addInput: "إضافة مدخل", up: "نقل للأعلى", down: "نقل للأسفل", commaList: "أ، ب، ج",
      compiled: "يحفظ تعبيرا واحدا يقيمه محرك سير العمل، ويبقى الجدول قابلا للتعديل هنا.",
    },
    logic: { intro: "شروط على بيانات القضية، يلزم تحقق جميعها أو أحدها.", json: "العرض بصيغة JSON", visual: "العرض شروطا" },
    tests: {
      title: "حالات الاختبار", intro: "قضايا نموذجية والنتيجة المطلوبة من القاعدة لكل منها، ويلزم نجاحها جميعا قبل النشر.",
      add: "إضافة حالة اختبار", run: "تشغيل الاختبارات", none: "لا توجد حالات اختبار بعد.", name: "الاسم", caseName: "الحالة {{n}}",
      expected: "المتوقع", input: "بيانات القضية (JSON)", passed: "ناجحة", got: "النتيجة {{value}}",
      summary: "الناجحة: {{passed}} من {{total}}", allPass: "كل حالات الاختبار تعطي النتيجة المتوقعة.", someFail: "بعض حالات الاختبار تعطي نتيجة مختلفة، ولا تنشر القاعدة حتى تنجح.",
    },
    case: {
      title: "التجربة على قضية فعلية", intro: "يقيم هذه النسخة (محفوظة أو لا) على بيانات قضية كما يفعل سير العمل تماما، ويعرض القيم التي قرأها.",
      check: "فحص", notFound: "لا توجد قضية بهذا الرقم.", holds: "القاعدة متحققة في {{number}}.", fails: "القاعدة غير متحققة في {{number}}.", value: "تعطي القاعدة في {{number}} القيمة {{value}}.",
      field: "الحقل", valueCol: "القيمة في القضية",
    },
    settings: {
      title: "الإعدادات", intro: "نوع القاعدة والخدمة التي تتبعها وما يقرؤه الموظفون عندما توقف خطوة.",
      serviceHint: "يقصر قائمة الحقول على نموذج تلك الخدمة. القواعد العامة ترى حقول القضية فقط.",
      explanationHint: "يظهر بجانب الخطوة الموقوفة.",
      usage: "يشير سير العمل إلى هذه القاعدة بالمفتاح {{key}}.",
    },
    lint: { inputs: "يحتاج الجدول إلى مدخل واحد على الأقل.", rows: "يحتاج الجدول إلى صف واحد على الأقل.", noTests: "لا توجد حالات اختبار، ولا تنشر القاعدة دون حالة واحدة على الأقل." },
  },
  tools: {
    title: "أدوات الوكلاء",
    subtitle: "صيغ وعمليات بحث واستدعاءات لأنظمة أخرى، تعرف مرة واحدة وتمنح لأي وكيل باسم tool.<key>. تختبر كل أداة قبل أن يستخدمها الوكلاء.",
    new: "أداة جديدة",
    emptyTitle: "لا توجد أدوات بعد",
    emptyBody: "تمنح الأداة الوكلاء إجابة دقيقة بدلا من التخمين: رسما من صيغة، أو حدا من جدول مرجعي، أو رقما من نظام آخر.",
    summary: "{{kind}} · المدخلات: {{inputs}} · حالات الاختبار: {{tests}}",
    help: {
      what: "يستدعي الوكيل الأداة المنشورة أثناء التشغيل. يجوز اقتباس الأرقام التي تعيدها في المسودة، وتنبه ضوابط الأرقام إلى أي رقم من مصدر آخر.",
      kinds: "الصيغة: تعبير على مدخلات محددة النوع. البحث: يجد سجلات من نوع معين حسب قيم الحقول. الموصل: عملية قراءة واحدة من موصل منشور.",
      tests: "تحتاج أدوات الصيغة والبحث إلى حالة اختبار واحدة على الأقل، ويجب أن تنجح جميع الحالات قبل نشر الأداة.",
    },
    kinds: { formula: "صيغة", lookup: "بحث", connector: "موصل" },
    inputTypes: { number: "رقم", text: "نص", boolean: "نعم/لا", date: "تاريخ" },
    lookupOps: { eq: "يساوي", contains: "يحتوي على", lt: "أقل من", lte: "لا يزيد على", gt: "أكبر من", gte: "لا يقل عن" },
    tabs: { definition: "التعريف", tests: "الاختبارات" },
    fields: { kind: "النوع", purpose: "وظيفة الأداة", purposeHint: "يقرأ الوكيل هذا الوصف ليقرر متى يستدعي الأداة.", output: "ما تعيده", outputHint: "وحدة النتيجة أو معناها، مثل \"الرسم بالدرهم\". يقرؤها الوكيل مع النتيجة." },
    columns: { kind: "النوع", grant: "اسم المنح", tests: "الاختبارات" },
    stats: { tested: "اختبارات ناجحة", testedHint: "الأدوات التي نجح آخر اختبار لها" },
    purpose: { title: "الغرض", intro: "يقرأ الوكيل هذا الوصف ليقرر متى يستدعي الأداة. تمنح للوكيل باسم {{key}}." },
    inputs: { title: "المدخلات", intro: "ما يجب أن يقدمه الوكيل. يتحقق من الأرقام والتواريخ قبل تشغيل الأداة.", add: "إضافة مدخل", none: "لا توجد مدخلات.", label: "التسمية", key: "المفتاح", type: "النوع", required: "إلزامي", remove: "إزالة" },
    formula: {
      title: "الصيغة",
      intro: "تعبير JsonLogic على المدخلات، أو كائن بنتائج مسماة لكل منها تعبيره.",
      invalid: "النص ليس JSON صالحا بعد؛ يحتفظ بآخر صيغة صالحة.",
      help: "المدخلات المتاحة بصيغة {\"var\": \"key\"}: {{vars}}. مثال: {\"*\": [{\"var\": \"turnover\"}, 0.001]}.",
    },
    lookup: {
      title: "البحث",
      intro: "يجد سجلات من نوع واحد تطابق حقولها المدخلات، ويعيد الحقول المحددة.",
      recordType: "نوع السجل", limit: "الحد الأقصى للسجلات المعادة", match: "المطابقة على", addMatch: "إضافة مطابقة",
      field: "حقل السجل", op: "الشرط", input: "المدخل", returns: "الحقول المعادة", returnsHint: "عند عدم التحديد تعاد جميع الحقول.",
    },
    connector: {
      title: "عملية الموصل",
      intro: "تستدعي الأداة عملية واحدة من موصل منشور، وتصبح معاملاتها مدخلات الأداة.",
      operation: "العملية",
      readOnly: "تعرض عمليات القراءة فقط: الوكلاء يقرؤون، والتغييرات تتم عبر إجراء معتمد.",
    },
    try: { title: "التجربة", intro: "استدعاء واحد بهذه المدخلات كما يجريه الوكيل.", run: "تشغيل", ok: "النتيجة", failed: "تعذر الاستدعاء" },
    tests: {
      title: "حالات الاختبار", intro: "تحدد كل حالة مدخلات والنتيجة المتوقعة. يجب أن تنجح جميعها قبل تفعيل الأداة.",
      add: "إضافة حالة", run: "تشغيل الكل", none: "لا توجد حالات اختبار بعد.", caseName: "الحالة {{n}}", name: "الاسم", input: "المدخلات", expected: "النتيجة المتوقعة",
      expectedHint: "رقم أو نص، أو كائن يذكر الحقول المطلوب فحصها فقط (مثل {\"count\": 1}).",
      summary: "نجح {{passed}} من {{total}}", allPass: "نجحت جميع الحالات.", someFail: "بعض الحالات لم تنجح؛ لا يمكن نشر الأداة حتى تنجح.",
      passed: "نجحت", got: "كانت النتيجة {{value}}",
    },
    lint: {
      purpose: "وصف وظيفة الأداة مطلوب.", expression: "الصيغة تحتاج إلى تعبير.", recordType: "نوع السجل المطلوب البحث فيه غير محدد.",
      operation: "عملية الموصل غير محددة.", inputKey: "كل مدخل يحتاج إلى مفتاح.", noTests: "لا توجد حالات اختبار: لا يمكن نشر الأداة دون حالة واحدة على الأقل.",
    },
  },
  screens: {
    title: "الشاشات",
    subtitle: "صفحات تبنى من كتل: قوائم السجلات ونماذجها وتفاصيلها، والتقارير والأرقام، ونماذج طلب الخدمات وعرض الملفات. تظهر في المكتب الخلفي أو البوابة على المسار ‎/s/<key>‎.",
    new: "شاشة جديدة",
    emptyTitle: "لا توجد شاشات بعد",
    emptyBody: "تمنح الشاشة الإدارة صفحتها الخاصة دون برمجة: سجل لبياناتها، أو نموذج طلب لخدمة جديدة، أو لوحة لتقاريرها.",
    summary: "{{surface}} · {{kind}} · عدد الكتل: {{count}}",
    help: {
      what: "الشاشة قائمة مرتبة من الكتل. تعرض كل كتلة بيانات فعلية: سجلات من نوع معين، أو تقريرا، أو ملفات خدمة، أو نموذج الطلب الذي يبدأ الخدمة.",
      portal: "تعرض شاشات البوابة العناوين والنصوص ونماذج طلب الخدمات وملفات مقدم الطلب فقط. ويشترط أن تكون خدمة البوابة منشورة ومتاحة لمقدمي الطلبات.",
      release: "تنشر الشاشات كغيرها من التعريفات: إصدار، ثم موافقة معتمد ثان، ثم النشر. ويظهر عنصر القائمة فور نشر الشاشة.",
    },
    fields: { surface: "مكان الظهور", kind: "النوع", recordType: "نوع السجل", service: "الخدمة" },
    surfaces: { backoffice: "المكتب الخلفي", portal: "البوابة" },
    kinds: { list: "قائمة", detail: "تفاصيل", dashboard: "لوحة معلومات", form: "نموذج" },
    tabs: { design: "الكتل", settings: "القائمة والصلاحيات" },
    blocks: {
      heading: { name: "عنوان", hint: "عنوان وسطر تحته." },
      text: { name: "نص", hint: "فقرة إرشادية." },
      recordList: { name: "قائمة سجلات", hint: "قائمة سجلات قابلة للبحث ومقسمة إلى صفحات، مع زر إنشاء اختياري." },
      recordForm: { name: "نموذج سجل", hint: "ينشئ سجلا، وتطبق فحوصات نوع السجل عند الحفظ." },
      recordDetail: { name: "تفاصيل سجل", hint: "السجل المختار من القائمة مع روابطه." },
      report: { name: "تقرير", hint: "تقرير منشور على شكل جدول أو رسم بياني." },
      kpi: { name: "رقم", hint: "رقم واحد من تقرير. تظهر الأرقام المتتالية في صف واحد." },
      serviceStart: { name: "طلب خدمة", hint: "نموذج الطلب المنشور للخدمة، ويفتح التقديم ملفا جديدا." },
      caseList: { name: "قائمة ملفات", hint: "ملفات الخدمة. وفي البوابة: ملفات مقدم الطلب فقط." },
      caseDetail: { name: "تفاصيل ملف", hint: "الملف المختار من القائمة: المراحل والخطوات التالية والمهام والسجل الزمني والمستندات." },
    },
    moveUp: "نقل للأعلى",
    moveDown: "نقل للأسفل",
    noBlocks: "لا توجد كتل بعد. تضاف الكتلة الأولى من الأسفل.",
    addBlock: "إضافة كتلة",
    notPublished: "غير منشور بعد: تنشر الشاشة معه في الإصدار نفسه أو بعده.",
    draft: "مسودة",
    arabic: "بالعربية",
    preview: {
      title: "معاينة مباشرة",
      backoffice: "كما يراها الموظفون، ببيانات فعلية. النماذج لا ترسل في المعاينة.",
      portal: "كما يراها مقدمو الطلبات. تقرأ المعاينة البيانات بصلاحياتك كموظف، ولا يرى مقدم الطلب إلا ملفاته.",
    },
    props: {
      heading: "العنوان", subtitle: "العنوان الفرعي", text: "النص", title: "العنوان", label: "التسمية", intro: "المقدمة",
      pageSize: "الصفوف في كل صفحة", columns: "الأعمدة", columnsHint: "عند عدم الاختيار: الحقول المحددة للعرض في القوائم في نوع السجل.",
      allowCreate: "إظهار زر الإنشاء", fields: "الحقول", fieldsHint: "عند عدم الاختيار: جميع الحقول.", submitLabel: "تسمية الزر",
      showLinks: "إظهار الروابط بالسجلات والملفات الأخرى", report: "التقرير", column: "العمود", columnHint: "مفتاح عمود التقرير، ويترك فارغا لأول عمود رقمي.",
      showActions: "الخطوات التالية (أزرار سير العمل)", showTasks: "المهام", showTimeline: "السجل الزمني", showDocuments: "المستندات",
    },
    settings: {
      whereTitle: "مكان الظهور",
      whereIntro: "تفتح الشاشة على المسار {{path}} في المكتب الخلفي أو البوابة.",
      portalNote: "تظهر الشاشة في القائمة العلوية للبوابة لمقدمي الطلبات بعد تسجيل الدخول.",
      menuTitle: "القائمة",
      menuIntro: "تظهر الشاشات المنشورة في قائمة مكان ظهورها بالترتيب أدناه.",
      showInMenu: "إظهار في القائمة",
      icon: "الأيقونة",
      order: "الترتيب",
      orderHint: "الأرقام الأصغر تظهر أولا.",
      accessTitle: "من يراها",
      accessIntro: "يرى الشاشة الموظفون الذين يحملون أحد الأدوار المختارة، ويراها المسؤولون دائما.",
      accessAll: "لم يختر أي دور: يرى الشاشة جميع الموظفين.",
      accessSome: "الأدوار المختارة: {{count}}.",
    },
    lint: {
      noBlocks: "تحتاج الشاشة إلى كتلة واحدة على الأقل.",
      portalBlock: "الكتلة {{n}} ({{block}}) لا يمكن عرضها في البوابة.",
      missingRef: "الكتلة {{n}} ({{block}}) تحتاج إلى نوع السجل أو التقرير أو الخدمة.",
      emptyText: "لا يوجد نص في الكتلة رقم {{n}}.",
      detailWithoutList: "تعرض كتلة تفاصيل السجل السجل المختار من قائمة، ولا توجد قائمة سجلات في الشاشة.",
      caseDetailWithoutList: "تعرض كتلة تفاصيل الملف الملف المختار من قائمة، ولا توجد قائمة ملفات في الشاشة.",
    },
  },
  environments: {
    title: "البيئات",
    subtitle: "تنتقل التغييرات من بيئة التطوير إلى بيئة الاختبار ثم إلى بيئة الإنتاج. وتعتمد كل بيئة ما تستلمه، ويمكن لكل منها التراجع بشكل مستقل.",
    help: {
      path: "يمكن ترقية الإصدار المنشور إلى البيئة التالية في المسار، حيث يصل كإصدار بانتظار اعتماد المعتمدين في تلك البيئة.",
      signing: "تحمل كل ترقية توقيعا بمفتاح الثقة المشترك بين البيئات، فلا تقبل البيئة الحزم إلا من البيئة التي تسبقها.",
      rollback: "يمكن التراجع عن الإصدار الذي وصل بالترقية في هذه البيئة دون المساس بالبيئات الأخرى.",
    },
    thisOne: "هذه البيئة",
    trustKey: "مفتاح الثقة",
    promoteTitle: "ترقية إصدار منشور",
    promoteIntro: "إرسال إصدار منشور إلى {{env}}، حيث ينتظر الاعتماد.",
    lastEnvironment: "هذه آخر بيئة في المسار، ولا توجد بيئة تالية للترقية إليها.",
    noPublished: "لا توجد نسخ منشورة بعد.",
    releaseMeta: "عدد العناصر: {{count}} · تاريخ النشر {{date}}",
    alreadyPromoted: "تمت الترقية",
    promoteTo: "ترقية إلى {{env}}",
    promoted: "أرسل إلى {{env}} للاعتماد.",
    promoteFailed: "تعذرت الترقية: {{error}}",
    matrixTitle: "النسخ في كل بيئة",
    matrixIntro: "النسخة المنشورة لكل تعريف تمت ترقيته في كل بيئة. لكل بيئة ترقيمها الخاص؛ اللون الأخضر يعني أن جميعها تعمل بالمحتوى نفسه.",
    matrixEmpty: "لم تتم ترقية أي شيء بعد.",
    present: "موجود",
    definition: "التعريف",
    unreachable: "تعذر الوصول إلى {{env}}: {{error}}",
    refresh: "تحديث",
    historyTitle: "سجل الترقيات",
    historyIntro: "الترقيات المرسلة من هذه البيئة والمستلمة فيها، مع بصمة الحزمة.",
    noHistory: "لا توجد ترقيات بعد",
    noHistoryBody: "تظهر هنا الإصدارات المنشورة بعد ترقيتها.",
    columns: { release: "الإصدار", path: "من ← إلى", items: "المحتوى", status: "الحالة", by: "مقدم الطلب" },
    evaluationsCarried: "نتائج اختبار الوكلاء المرفقة: {{count}}",
    status: { Sent: "مرسل", Received: "بانتظار الاعتماد", Published: "مفعل", RolledBack: "تم التراجع", Failed: "فشل", Rejected: "مرفوض" },
    rollbackHere: "التراجع هنا",
    review: "مراجعة",
    rollbackTitle: "التراجع في {{env}}",
    rollbackIntro: "تعود التعريفات في هذا الإصدار إلى النسخ التي كانت مفعلة قبل وصوله، دون أن تتأثر البيئات الأخرى.",
    reason: "السبب",
    rolledBack: "تم التراجع في {{env}}.",
    editTitle: "تعديل {{env}}",
    editIntro: "عنوان الوصول إلى هذه البيئة والمفتاح الذي تثق به.",
    saved: "تم حفظ البيئة.",
    fields: { name: "الاسم", nameAr: "الاسم بالعربية", baseUrl: "العنوان", trustKey: "مفتاح الثقة", trustKeyHint: "مرجع سري مثل secret://promotion.trust، ويبقى المفتاح نفسه في مخزن الأسرار.", order: "الترتيب في المسار", enabled: "مفعلة" },
    promoteFromRelease: "ترقية إلى {{env}}",
    promoteFromReleaseHint: "إرسال هذا الإصدار إلى {{env}}، حيث ينتظر الاعتماد.",
  },
} as const;
